import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import QS from 'qs';
import Base from './base';
var HOLDING_AREA_PAGINATION_LIMIT = 200;

/**
 * `Service` Definition of HoldingArea service, which is used for fetching Holding Area related data
 */
var HoldingArea = /*#__PURE__*/function (_Base) {
  /**
   * Create HoldingArea service instance
   *
   * @param sdk - SDK instance
   */
  function HoldingArea(sdk) {
    _classCallCheck(this, HoldingArea);
    return _callSuper(this, HoldingArea, [sdk]);
  }

  /**
   * Static getter of the class name
   *
   * @returns The detail property name used by SDK instance.
   */
  _inherits(HoldingArea, _Base);
  return _createClass(HoldingArea, [{
    key: "getItems",
    value: (
    /**
     * Get the holding area documents by project
     * https://stoplight.autodesk.com/acs/acs-docs/version%2F3.0/ACC-Documents.oas2.yml?view=/other-operation/querydocumentsofproject
     *
     * @param projectId -  the project uuid
     * @param params - used to show how many items to get or which item to start from, With the shape of
     *                      limit: integer, offset: integer
     * @param config - configurable object to overwrite request parameters.
     */
    function () {
      var _getItems = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(projectId, params, config) {
        var url;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              url = "/projects/".concat(projectId, "/holding-area/documents").concat(QS.stringify(_extends({
                limit: HOLDING_AREA_PAGINATION_LIMIT
              }, params), {
                addQueryPrefix: true
              }));
              _context.next = 3;
              return this.HttpService.dmV3.get(url, config);
            case 3:
              return _context.abrupt("return", _context.sent.data);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getItems(_x, _x2, _x3) {
        return _getItems.apply(this, arguments);
      }
      return getItems;
    }()
    /**
     * Rename holding area documents
     * https://platform.stoplight.autodesk.com/docs/docs-cp/f6dcb930c6e89-shared-batch-rename-documents
     *
     * @param projectId -  the project uuid
     * @param payload - used to show how many items to get or which item to start from, With the shape of
     *                      urn: string, name: string, attributes: object
     * @param config - configurable object to overwrite request parameters.
     */
    )
  }, {
    key: "renameItems",
    value: (function () {
      var _renameItems = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(projectId, payload, config) {
        var url;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              url = "/projects/".concat(projectId, "/documents:batch-rename");
              _context2.next = 3;
              return this.HttpService.dmV3.post(url, payload, config);
            case 3:
              return _context2.abrupt("return", _context2.sent.data);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function renameItems(_x4, _x5, _x6) {
        return _renameItems.apply(this, arguments);
      }
      return renameItems;
    }()
    /**
     * Delete holding area documents
     * https://platform.stoplight.autodesk.com/docs/docs-cp/1ffc2e4795c93-shared-batch-delete-documents
     *
     * @param projectId -  the project uuid
     * @param payload - used to show how many items to get or which item to start from, With the shape of
     *                      [urn: string]
     * @param config - configurable object to overwrite request parameters.
     */
    )
  }, {
    key: "deleteItems",
    value: (function () {
      var _deleteItems = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(projectId, payload, config) {
        var url;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              url = "/projects/".concat(projectId, "/documents:delete");
              _context3.next = 3;
              return this.HttpService.dmV3.post(url, payload, config);
            case 3:
              return _context3.abrupt("return", _context3.sent.data);
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function deleteItems(_x7, _x8, _x9) {
        return _deleteItems.apply(this, arguments);
      }
      return deleteItems;
    }())
  }], [{
    key: "getName",
    value: function getName() {
      return 'HoldingArea';
    }
  }]);
}(Base);
export default HoldingArea;